import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import BagCostsPage from '../pages/BagCostsPage';
import BagMaterialCostPage from '../pages/BagMaterialCostPage';
import ChargeByStylePage from '../pages/ChargeByStylePage';
import CommoditiesPage from '../pages/CommoditiesPage';
import LaborCostsPage from '../pages/LaborCostsPage';
import MethodsPage from '../pages/MethodsPage';
import PackTypePage from '../pages/PackTypePage';
import SetupChargePage from '../pages/SetupChargePage';
import SizeOptionsPage from '../pages/SizeOptionsPage';
import CustomersPage from '../pages/CustomersPage';
import VarietiesPage from '../pages/VarietiesPage';
import GradesPage from '../pages/GradesPage';
import TiHiPage from '../pages/TiHiPage';
import CaseTagsPage from '../pages/CaseTagsPage';
import BagTraceabilityPage from '../pages/BagTraceabilityPage';
import CustomerSpecsFormPage from '../pages/CustomerSpecs/CustomerSpecsFormPage';
import CustomerSpecsManagePage from '../pages/CustomerSpecs/CustomerSpecsManagePage';
import CustomerSpecsIndexPage from '../pages/CustomerSpecs/CustomerSpecsIndexPage';
import PidMethodsPage from '../pages/PidMethodsPage';
import ChargeSearchIndexPage from '../pages/ChargeSearchIndexPage';
import PackageIndexPage from '../pages/PackageIndexPage';
import PidBagsPage from '../pages/PidBagsPage';
import PidPLUPage from '../pages/PidPLUPage';
import PidUPCPage from '../pages/PidUPCPage';
import PidDisplaysPage from '../pages/PidDisplaysPage';
import SettingsPage from '../pages/Settings/SettingsPage';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import GroupLanding from '../routes/GroupLanding';
import RequireAuth from '../components/RequireAuth';
import { PERMISSIONS } from '../auth/permissions';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<RequireAuth><HomePage /></RequireAuth>} />

    {/* Group landing routes */}
    <Route path="/dt" element={
      <RequireAuth permissions={[PERMISSIONS.DataTablesRead]}>
        <GroupLanding groupKey="datatables" />
      </RequireAuth>
    } />
    <Route path="/charges" element={
      <RequireAuth permissions={[PERMISSIONS.ChargesRead]}>
        <GroupLanding groupKey="charges" />
      </RequireAuth>
    } />
    <Route path="/packaging" element={
      <RequireAuth permissions={[PERMISSIONS.PackagingIndex]}>
        <GroupLanding groupKey="packaging" />
      </RequireAuth>
    } />
    <Route path="/customer-specs" element={
      <RequireAuth permissions={[PERMISSIONS.CustomerSpecsIndex]}>
        <GroupLanding groupKey="customer-specs" />
      </RequireAuth>
    } />

    {/* DataTables (Admin only) */}
    <Route path="/commodities" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><CommoditiesPage /></RequireAuth>} />
    <Route path="/customers" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><CustomersPage /></RequireAuth>} />
    <Route path="/varieties" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><VarietiesPage /></RequireAuth>} />
    <Route path="/grades" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><GradesPage /></RequireAuth>} />
    <Route path="/tihi" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><TiHiPage /></RequireAuth>} />
    <Route path="/case-tags" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><CaseTagsPage /></RequireAuth>} />
    <Route path="/bag-traceability" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><BagTraceabilityPage /></RequireAuth>} />
    <Route path="/bag-costs" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><BagCostsPage /></RequireAuth>} />
    <Route path="/bag-material" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><BagMaterialCostPage /></RequireAuth>} />
    <Route path="/labor" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><LaborCostsPage /></RequireAuth>} />
    <Route path="/methods" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><MethodsPage /></RequireAuth>} />
    <Route path="/pack-types" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><PackTypePage /></RequireAuth>} />
    <Route path="/setup-charges" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><SetupChargePage /></RequireAuth>} />
    <Route path="/size-options" element={<RequireAuth permissions={[PERMISSIONS.DataTablesRead]}><SizeOptionsPage /></RequireAuth>} />

    {/* Charges */}
    <Route path="/charge-by-style" element={<RequireAuth permissions={[PERMISSIONS.ChargesAll]}><ChargeByStylePage /></RequireAuth>} />
    <Route path="/charge-search-index" element={<RequireAuth permissions={[PERMISSIONS.ChargesRead]}><ChargeSearchIndexPage /></RequireAuth>} />

    {/* Packaging */}
    <Route path="/package-index" element={<RequireAuth permissions={[PERMISSIONS.PackagingIndex]}><PackageIndexPage /></RequireAuth>} />
    <Route path="/pid-methods" element={<RequireAuth permissions={[PERMISSIONS.PackagingAll]}><PidMethodsPage /></RequireAuth>} />
    <Route path="/pid-bags" element={<RequireAuth permissions={[PERMISSIONS.PackagingAll]}><PidBagsPage /></RequireAuth>} />
    <Route path="/pid-plu" element={<RequireAuth permissions={[PERMISSIONS.PackagingAll]}><PidPLUPage /></RequireAuth>} />
    <Route path="/pid-upc" element={<RequireAuth permissions={[PERMISSIONS.PackagingAll]}><PidUPCPage /></RequireAuth>} />
    <Route path="/pid-displays" element={<RequireAuth permissions={[PERMISSIONS.PackagingAll]}><PidDisplaysPage /></RequireAuth>} />

    {/* Customer Specifications (Admin only) */}
    <Route path="/CustomerSpecs/Form" element={<RequireAuth permissions={[PERMISSIONS.CustomerSpecsAll]}><CustomerSpecsFormPage /></RequireAuth>} />
    <Route path="/CustomerSpecs/Index" element={<RequireAuth permissions={[PERMISSIONS.CustomerSpecsIndex]}><CustomerSpecsIndexPage /></RequireAuth>} />
    <Route path="/CustomerSpecs/Manage" element={<RequireAuth permissions={[PERMISSIONS.CustomerSpecsAll]}><CustomerSpecsManagePage /></RequireAuth>} />

    <Route path="/settings" element={<SettingsPage />} />
    <Route path="/unauthorized" element={<UnauthorizedPage />} />
    <Route path="*" element={<div style={{ padding: '2rem' }}><h2>Page not found</h2></div>} />
  </Routes>
);

export default AppRoutes;


